import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="arxiv-reference"
//
// The reference field. It fills itself from an example, and refuses a value the
// server would refuse anyway — said beside the field, where the value is, not
// in a flash after a round trip. The pattern is the server's own (see
// Arxiv::SourceResolver::REFERENCE_PATTERN) and the message arrives translated,
// so neither is written twice.
//
// The examples are buttons, not links: pressing one changes what the form
// holds, not which page you are on. Nothing is converted until the visitor
// presses submit — a guest only gets about three conversions a month, and three
// examples would spend all of them.
export default class extends Controller {
  static targets = ["input", "error"]
  static values = { pattern: String, message: String }

  fill({ params: { reference } }) {
    this.inputTarget.value = reference
    this.clear()
    // preventScroll: the field is already on the first screen, and moving the
    // page would hide the headline the visitor has just read.
    this.inputTarget.focus({ preventScroll: true })
  }

  validate(event) {
    if (this.isValid) return this.clear()

    event.preventDefault()
    // The funnel counts this same submit as a paste. A refused press is not
    // one, so it stops here.
    event.stopImmediatePropagation()
    this.errorTarget.textContent = this.messageValue
    this.errorTarget.classList.remove("hidden")
    this.inputTarget.classList.add("input--error")
    this.inputTarget.setAttribute("aria-invalid", "true")
    this.inputTarget.focus({ preventScroll: true })
  }

  clear() {
    this.errorTarget.classList.add("hidden")
    this.inputTarget.classList.remove("input--error")
    this.inputTarget.removeAttribute("aria-invalid")
  }

  // An empty field is the browser's to complain about — the input is required.
  get isValid() {
    const value = this.inputTarget.value.trim()
    return value === "" || new RegExp(`^(?:${this.patternValue})$`, "i").test(value)
  }
}
